import React, { useCallback, useMemo } from 'react';
import { format } from 'date-fns';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { muteErrorAndResult, useFetchOld } from 'hooks';
import EnterAmountView from 'features/pay/components/EnterAmountView';
import { getGroupById, saveGroupTransaction } from 'actions';
import { selectUserId } from 'reducers/selectors';
import { getCreditAndDebt } from 'features/pay/actions/payments';
const GroupSettleOfflineScreen = ({ route, navigation, }) => {
    const { group, payer, payee, fullAmount } = route.params;
    const [, , isFetching, fetch] = useFetchOld(muteErrorAndResult);
    const userId = useAppSelector(selectUserId);
    const dispatch = useAppDispatch();
    const isPaying = userId === payer.id;
    const counterParty = useMemo(() => (isPaying ? payee : payer), [isPaying, payee, payer]);
    const counterpartyName = [counterParty.firstName, counterParty.lastName].filter(Boolean).join(' ') ||
        ('handle' in counterParty && counterParty.handle) ||
        'Your friend';
    const onSubmit = useCallback(async (amount, counterpartName) => {
        const date = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
        const res = await fetch(saveGroupTransaction(group.id, {
            amount: -Math.abs(amount),
            counterpartName,
            currency: group.netBalance.currency,
            date,
            paidBy: payer.id,
            split: { [payee.id]: 1 },
            isSettlement: true,
        }));
        if (!res)
            return;
        dispatch(getGroupById(group.id));
        dispatch(getCreditAndDebt());
        navigation.pop(2);
        // The app shows the payment in the Pay activity screen, which isn't on web
        navigation.navigateDeprecated('Success', {
            title: 'Payment recorded',
            subTitle: isPaying
                ? `You paid ${counterpartyName}`
                : `${counterpartyName} paid you`,
            buttonText: 'Done',
            onContinue: () => {
                navigation.goBack();
                return true;
            },
        });
    }, [
        counterpartyName,
        group.id,
        group.netBalance.currency,
        isPaying,
        payee.id,
        payer.id,
    ]);
    const contact = useMemo(() => {
        if ('handle' in counterParty && counterParty.handle) {
            return {
                handle: counterParty.handle,
                givenName: counterParty.firstName || '',
                familyName: counterParty.lastName || '',
                thumbnailPath: counterParty.profilePicUrl,
            };
        }
        if ('urlHandle' in counterParty && counterParty.urlHandle) {
            return {
                handle: counterParty.urlHandle,
                givenName: counterParty.firstName || '',
                familyName: counterParty.lastName || '',
                thumbnailPath: counterParty.userImage,
            };
        }
        return {};
    }, [counterParty]);
    const to = useMemo(() => ({
        contact: {
            ...contact,
            phoneNumbers: [],
        },
        itemType: 'pay',
    }), [contact]);
    return (<EnterAmountView buttonLabel="Continue" to={to} initialReference="Debt settlement" initialAmount={Math.abs(fullAmount)} loading={isFetching} onSubmit={onSubmit}/>);
};
export default GroupSettleOfflineScreen;
